var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.samples.length >= 2
    ? _c("div", { staticClass: "zoneEchantillons" }, [
        _c("h2", [_vm._v("Choisissez 2 échantillons")]),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "containerCarousel" } },
          [
            _c(
              "carousel",
              {
                attrs: {
                  id: "carouselSamples",
                  perPageCustom: [[0, 1], [600, 2], [800, 3], [1200, 4]],
                  paginationEnabled: false,
                  navigationEnabled: true,
                  navigationPrevLabel:
                    "<img width='20px' src='bundles/site/img/arrowLeft.svg' class='svg'>",
                  navigationNextLabel:
                    "<img width='20px' src='bundles/site/img/arrowRight.svg' class='svg'>"
                }
              },
              _vm._l(_vm.samples, function(sample) {
                return _c("slide", { key: sample.id }, [
                  _c("div", { staticClass: "custom-control custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checkedSamples,
                          expression: "checkedSamples"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: { type: "checkbox", id: "input-" + sample.id },
                      domProps: {
                        value: sample.id,
                        checked: Array.isArray(_vm.checkedSamples)
                          ? _vm._i(_vm.checkedSamples, sample.id) > -1
                          : _vm.checkedSamples
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.checkedSamples,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = sample.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.checkedSamples = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.checkedSamples = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.checkedSamples = $$c
                            }
                          },
                          function($event) {
                            _vm.onChange($event, sample.id)
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: {
                          for: "input-" + sample.id,
                          name: "input-" + sample.id
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "lazyload",
                          attrs: {
                            "data-src": sample.image.path,
                            alt: sample.title
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(sample.title))])
                      ]
                    )
                  ])
                ])
              })
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5011adf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5011adf6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartSamples.vue
// module id = 572
// module chunks = 1